/* ------------------------------------------------------------------ *
 * The one sanctioned cast in the routing layer.
 *
 * TanStack Router types `to` against the literal union of paths it can
 * infer from the route tree. Prody's tree is *generated* from the
 * module registry — `MODULES.flatMap(m => m.routes.map(createRoute))` —
 * so there is no literal union to infer, and every navigation would
 * otherwise need a cast at its call site.
 *
 * Confining it here means:
 *   - `grep 'as never'` in this codebase returns seed-data brands and
 *     nothing else;
 *   - if the registry ever gains build-time codegen, this file is the
 *     single thing to delete.
 *
 * Paths are still built from `businessPath()`, so the tenant segment
 * cannot be forgotten.
 * ------------------------------------------------------------------ */

/** Widen a generated path for TanStack Router's `to` prop. */
export const path = (p: string): '/' => p as unknown as '/';

/** `/b/verdal` — the root of a tenant. */
export const businessPath = (slug: string): string => `/b/${slug}`;

/** `/b/verdal/orders` — a module inside a tenant. */
export const modulePath = (slug: string, to: string): string =>
  to ? `${businessPath(slug)}/${to}` : businessPath(slug);
